<div class="trailer" [ngClass]="{ 'selected' : isSelected }">
    <div class="topcols">
        <div class="trailer-number">
            <p>
                <span class="number">
                    {{trailer?.trailerNumber}}
                </span>
                @if (trailer?.trailerLength && trailer?.trailerType) {
<span class="length">
                    {{trailer?.trailerLength}}ft ({{trailer?.trailerType}})
                </span>
}
            </p>
        </div>
        <div class="destination-sort">
            @if (getLanguageCode() === 'fr') {
<div>
                <p>
                    <span class="destination-organization-name">
                        {{trailer?.destinationOrganizationAbbreviatedName}}
                    </span>
                    @if (formattedDueDate) {
<span class="due-date">
                        {{localize(langSection.TrailerCard, langText.Due)}} {{formattedDueDate}}
                    </span>
}
                </p>
            </div>
}
            @if (getLanguageCode() !== 'fr') {
<div>
                <p>
                    <span class="destination-organization-name">
                        {{trailer?.destinationOrganizationAbbreviatedName}}
                    </span>
                    @if (formattedDueDate) {
<span class="due-date">
                        {{localize(langSection.TrailerCard, langText.Due)}} {{formattedDueDate}}
                    </span>
}
                </p>
            </div>
}
        </div>
        <div class="sort-code">
            @if (getLanguageCode() === 'fr') {
<div>
                @if (trailer?.destinationSortCode) {
<p>
                    <span>{{localize(langSection.Term,langText.Sort)}} {{trailer?.destinationSortCode}}</span>
                    <span class="days-on-property">
                        {{trailer.daysOnProperty}} {{trailer.daysOnProperty > 1 ? localize(langSection.OnProperty, langText.DaysOP) : localize(langSection.OnProperty, langText.DayOP) }}
                    </span>
                </p>
}
            </div>
}
            @if (getLanguageCode() !== 'fr') {
<div>
                @if (trailer?.destinationSortCode) {
<p>
                    <span>{{trailer?.destinationSortCode}} {{localize(langSection.Term, langText.Sort)}}</span>
                    <span class="days-on-property">
                        {{trailer.daysOnProperty}} {{trailer.daysOnProperty > 1 ? localize(langSection.OnProperty, langText.DaysOP) : localize(langSection.OnProperty, langText.DayOP) }}
                    </span>
                </p>
}
            </div>
}
        </div>
        <div class="load-info position-relative">
            @if (trailer?.destinationSortCode) {
<span class="small percent">{{trailer?.percentFull}}%</span>
}
            <div class="long-svg"></div>
            @if (trailer?.destinationSortCode) {
<span class="small pieceCount">{{trailer?.pieceCount}}</span>
}
        </div>
    </div>
    <div class="bottomcols">
        @if(trailer?.requestId) {
            <div class="pull-time">
                <span class="label">{{localize(langSection.OnProperty, langText.PullTime)}}:</span> {{trailer?.pullTime}}
            </div>
        } 
        @else {
            <div class="available">
                {{ localize(langSection.OnProperty, langText.Available)}}
            </div>
        }
        <div class="serviceLevel">
            {{localizeValue(langSection.ServiceLevel, serviceLevelTranslate[trailer?.serviceType])}}
        </div>
        @if (trailer?.destinationSortCode) {
<div class="palletcount">
            {{trailer?.palletCount}} {{localize(langSection.TrailerCard, langText.Pallets)}}
        </div>
}
    </div>
    @if (isSelected) {
<div class="expanded">
        <div class="dashboard-request" (click)="openRequestInNewTab(); $event.stopPropagation()"><span class="ups-icon ups-icon-open-in-new"></span>Open In Dashboard</div>
    </div>
}
</div>